var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full"},[_c('div',{staticClass:"flex items-center mb-1"},[_c('div',{staticClass:"mr-4"},[(_vm.label)?_c('label',{staticClass:"font-bold",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.error)?_c('span',{staticClass:"mt-1 text-xs text-italic mt-1 text-red-500"},[_vm._v("\n                "+_vm._s(_vm.error)+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"my-quill-editor"},[_c('quill-editor',{attrs:{"options":{
                ..._vm.editorOptions,
                ...{
                    placeholder: _vm.placeholder,
                    modules: {
                        toolbar: _vm.toolbarOptions
                    }
                }
            }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }